<template>
  <div class="lens-widget">
    <iframe
      v-if="config.metabaseUrl"
      :src="config.metabaseUrl"
      frameborder="0"
      class="full-panel"
      allowtransparency
    ></iframe>
    <div v-else class="center">
      <p>Lens Questions will only display after a page refresh</p>
    </div>
    <div v-if="editing" class="full-panel"></div>
  </div>
</template>

<script>

  export default {
    props: {
      config: {
        type: Object,
        default: () => {
          return { metabaseUrl: null }
        }
      },
      editing: {
        type: Boolean,
        default: false
      }
    }


  }
</script>

<style scoped>
 .full-panel {
   position:absolute;
   top:0;
   left:0;
   width:100%;
   height:100%;
 }
 .center p {
   font-weight: bold;
   margin: 0;
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
 }
</style>